
import moment from "moment";
import { Component, Ref, Vue } from "vue-property-decorator";
import { findIndex } from "lodash";
import Utils from "@/mixin";
import { HeroLeader, VForm } from "@/type";

@Component({
  props: {
    editId: {
      type: [Number, String],
      default: "",
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    toggleDialog: {
      type: Function,
      // eslint-disable-next-line
      default: /* istanbul ignore next */ () => {},
    },
    setInitialDialog: {
      type: Function,
      // eslint-disable-next-line
      default: /* istanbul ignore next */ () => {},
    },
  },
  mixins: [Utils],
  computed: {
    validate() {
      const { startDate, endDate } = this.formData;
      if (
        (this.editId === "" && startDate === "") ||
        endDate === "" ||
        (this.editId !== "" && startDate === "") ||
        endDate === ""
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    editId(nextProps, prevProps) {
      /* istanbul ignore else */
      if (prevProps !== nextProps && nextProps !== "") {
        this.modalTitle = "Edit";
        const { heroLeaderList } = this;
        const index = findIndex(
          heroLeaderList,
          (i: HeroLeader) => i.id === nextProps
        );
        const data = heroLeaderList[index];
        this.formData = {
          startDate: moment(data.startDate, "YYYY-MM-DD HH:mm:ss").format(
            "YYYY-MM"
          ),
          title: data.title,
          level: data.level,
        };
      }
    },
  },
})
export default class HeroAnnouncementForm extends Vue {
  modalTitle = "Create";
  formData = {
    startDate: "",
    title: "",
    level: 6,
  };
  initialForm = {
    startDate: "",
    title: "",
    level: 6,
  };
  levelItems = [
    { text: "6 - พนักงานขาย", value: 6 },
    { text: "5 - หัวหน้าเขต", value: 5 },
    { text: "4 - หัวหน้าภาค", value: 4 },
  ];
  menu = false;
  /* istanbul ignore next */
  rules = {
    required: (value: [number, string]) => !!value || "Required.",
  };

  @Ref("form") readonly form!: VForm;
  createHeroWinner!: (formData: object) => void;
  editHeroWinner!: (formData: object) => void;
  toggleDialog!: () => void;

  clearData() {
    if (this.$props.editId !== "") this.$props.setInitialDialog();
    this.toggleDialog();
    this.$nextTick(() => {
      this.modalTitle = "Create";
      this.formData = Object.assign({}, this.initialForm);
      /* istanbul ignore next */
      if (this.form) this.form.resetValidation();
    });
  }

  submitForm() {
    const { formData } = this;
    if (this.$props.editId !== "") {
      const form = {
        ...formData,
        editId: this.$props.editId,
        startDate: moment(formData.startDate).add(9, "days").format(),
        endDate: moment(formData.startDate)
          .add(8, "days")
          .add(1, "months")
          .format(),
      };
      this.editHeroWinner(form);
    } else {
      const form = {
        ...formData,
        startDate: moment(formData.startDate).add(9, "days").format(),
        endDate: moment(formData.startDate)
          .add(8, "days")
          .add(1, "months")
          .format(),
      };
      this.createHeroWinner(form);
    }
    this.clearData();
  }
}
